"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMessageId = exports.validateAttachId = void 0;
var constants_1 = require("./constants");
/** Валидация айди аттача */
var validateAttachId = function (attachType, encodedAttachId, _a) {
    var cloudAttachIdReg = _a.cloudAttachIdReg, temporaryAttachIdReg = _a.temporaryAttachIdReg, attachIdReg = _a.attachIdReg, cloudStockAttachIdReg = _a.cloudStockAttachIdReg;
    switch (attachType) {
        case constants_1.AttachType.Cloud:
            return !!encodedAttachId.match(cloudAttachIdReg);
        case constants_1.AttachType.Temporary:
            return !!encodedAttachId.match(temporaryAttachIdReg);
        case constants_1.AttachType.Attach:
            return !!encodedAttachId.match(attachIdReg);
        case constants_1.AttachType.CloudStock:
            return !!encodedAttachId.match(cloudStockAttachIdReg);
        default:
            return false;
    }
};
exports.validateAttachId = validateAttachId;
/** Валидация айди письма */
var validateMessageId = function (attachType, messageId, _a) {
    var commonMessageIdReg = _a.commonMessageIdReg, temporaryMessageIdReg = _a.temporaryMessageIdReg;
    switch (attachType) {
        case constants_1.AttachType.Cloud:
        case constants_1.AttachType.Attach:
        case constants_1.AttachType.CloudStock:
            return !!messageId.match(commonMessageIdReg);
        case constants_1.AttachType.Temporary:
            return !!messageId.match(temporaryMessageIdReg);
        default:
            return false;
    }
};
exports.validateMessageId = validateMessageId;
//# sourceMappingURL=IdValidation.js.map